import {
	fetch,
	setpromise,
	fetchForDoterra,
	fetchForDoterraWX,
	sconfig,
	fetchForAPP,
	fetchForCVO,
	fetchForCDN,
} from '@/config/fetch'

const brandMenu = require('@/service/mock/brand')
const article = require('@/service/mock/article')
const issues = require('@/service/mock/issues')
if (sconfig.all||(!sconfig.all&&sconfig.common)) {
	
}
else{
	var getBrandMenus = (token,userId) => setpromise(brandMenu.brand)
	var getIssues = (token,vipno)=>setpromise(issues.issues);
	var getPageConfig = (token,uid,page) => fetchForCDN('GET', 'cgpc001', token, uid, {page,list:'list'});
	var getPageConfigDetail = (token,uid,page,module) => fetchForCDN('GET', 'cgpc002', token, uid, {page, module,list:'list'});

	var getUserInfo = (token, userToken) => fetchForCVO('GET', 'so002', token, null, {
		userToken,
	});
	var getWechatUser = (token,uid,v,lut) => fetchForDoterraWX('GET','mg010',token,uid,{v,lut});

	var sysConfig = (token, user_id, v, lut) => fetchForDoterra('GET', 'sl002', token, user_id, {
		v,
		lut,
		fr:1
	});
	var sysConfigCDN = (token, user_id, v, lut) => fetchForCDN('GET', 'sl002', token, user_id, {
		list:'list'
	});
	var getFiles = (token, uid,params) => fetchForDoterra('GET', 'oegfl001', token, uid,params);
	var getFileDetail = (token,uid,params) => fetchForDoterra('GET', 'oegf001', token, uid,params);
	var getMenuItems = (token,uid) => fetchForDoterra('GET', 'wsgm001', token, uid, {channel:'WebSite'});
	var searchByKeys = (token,uid,params) => fetchForDoterra('GET', 'wssd001', token, uid, params);
	var getCommunityCatalog = (token,uid,code) => fetchForDoterra('GET','cgcc001',token,uid,{code})
	var getCommunityList = (token,uid,params) => fetchForDoterra('GET','cgcl001',token,uid,params)
	var getCommunityArticle = (token,uid,params) => fetchForDoterra('GET','cgad001',token,uid,params)
	var getProvinces = (token, user_id, v, lut) => fetchForDoterraWX('GET', 'cg010', token, user_id, {
		v,
		lut
	});
	var getCitys = (token, user_id, v, lut) => fetchForDoterraWX('GET', 'cg011', token, user_id, {
		v,
		lut
	});
	var getDistricts = (token, user_id, v, lut) => fetchForDoterraWX('GET', 'cg012', token, user_id, {
		v,
		lut
	});
	var getTown = (token, user_id, code, v, lut) => fetchForDoterraWX('GET', 'cg013', token, user_id, {
		v,
		lut,
		code
	});
	var getELearnCourse = (token,uid,params) => fetchForDoterra('GET','oegc001',token,uid,params)
	var getELearnExam = (token,uid,params) => fetchForDoterra('GET','oege001',token,uid,params)
	var submitExam = (token,uid,params) => fetchForDoterra('POST','oepa001',token,uid,params)
	var getELearnCer = (token,uid,params) => fetchForDoterra('GET','oegmc001',token,uid,params)
	var reportLessonProgress = (token,uid,params) => fetchForDoterra('GET','oevl001',token,uid,params)
	var reportFileDownload = (token,uid,params) => fetchForDoterra('GET','oegf001',token,uid,params)
	var reportFileBrowse = (token,uid,params) => fetchForDoterra('GET','oegf001',token,uid,params)
	var getExamResult =  (token,uid,rcode) => fetchForDoterra('GET','gmeh002',token,uid,{rcode})
	var getExamRecord = (token,uid,lcode) => fetchForDoterra('GET','gmeh001',token,uid,{lcode})
	var getServiceConfig = (token,uid) => fetchForDoterra('GET','gudurl001',token,uid)
	var postFeedback = (token,vipno,params) => fetchForCVO('POST','Us001',token,vipno,params);
	var uploadImage = (token, user_id, idCard, type, imageData,model) => fetchForCVO('POST', 'mg015', token, user_id, {
		idCard,
		type,
		imageData,
		model
	});
	var logOut = (token, userToken) => fetchForCVO('GET', 'so006', token, null, {
		userToken
	});

	var getMaintenance = (token, user_id) => fetchForDoterra('GET', 'cgsm001', token, user_id);
	var recordBrowsing = (token,user_id,params) => fetchForAPP('GET','mcpv001',token,user_id,params)
	var getGuides = (token,user_id,type)=> fetchForDoterra('GET', 'cgp000', token, user_id,{type});
	var identifyAddress = (token,user_id,a) => fetch('GET','/webui/admin/public/ashx/address.ashx?t=','','',{a},'WECHAT')
	var observe = (token,user_id,params) => fetchForDoterra('POST', 'mcdc001', token, user_id,params,'client_api');
	var getOrphanModalCount = (token,user_id,VipNo) => fetchForDoterraWX('GET','orp001',token,user_id,{VipNo})
	
}
export {
	sysConfig,
	sysConfigCDN,
	getUserInfo,
	getWechatUser,
	getBrandMenus,
	getPageConfig,
	getPageConfigDetail,
	getIssues,
	getFiles,
	getFileDetail,
	getMenuItems,
	searchByKeys,
	getCommunityCatalog,
	getCommunityList,
	getCommunityArticle,

	getProvinces,
	getCitys,
	getDistricts,
	getTown,

	getELearnCourse,
	getELearnExam,
	submitExam,
	getELearnCer,
	reportLessonProgress,
	reportFileDownload,
	reportFileBrowse,
	getExamResult,
	getExamRecord,

	getServiceConfig,
	postFeedback,
	uploadImage,
	logOut,
	getMaintenance,
	recordBrowsing,
	getGuides,
	identifyAddress,
	observe,
	getOrphanModalCount,

	
}